export default __webpack_public_path__ + "static/media/cont1.ed7515f4.jpg";